import * as React from 'react';

import { debounce } from '@common/typescript/Utils';

import '@common/react/scss/components/bottomButton.scss';

interface Props {
	containerClassName?: string;
	className?: string;
	onClick: () => void;
}

const BottomButton: React.FC<Props> = (props) => {
	const {
		onClick,
		className = '',
		children,
		containerClassName = 'pull-left mobile-hidden',
	} = props;
	const [buttonVisible, changeButtonVisibility] = React.useState<boolean>(false);

	React.useEffect(
		() => {
			const handleScroll = () => {
				const header = document.querySelector('.header-container');

				if (header) {
					changeButtonVisibility(window.scrollY > header.clientHeight + 15);
				}
			};

			window.addEventListener('scroll', debounce(handleScroll, 300));

			return () => window.removeEventListener('scroll', debounce(handleScroll, 300));
		},
		[],
	);

	return <div className={`${containerClassName} bottom-btn-container ${
		buttonVisible ? 'bottom-btn-container_show' : ''}`}
	>
		<button
			type="button"
			className={`bottom-btn ${className}`}
			onClick={onClick}
		>
			{children}
		</button>
	</div>;
};

export default BottomButton;
